// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:28
import { LocationGeometry_abstract } from './../abstract/SagaSchema/LocationGeometry_abstract';
export class LocationGeometry extends LocationGeometry_abstract {}
